<template>
  <div>
    <p>Want to get in touch?</p>
    name<br><input v-model="name"><br>
    email<br><input v-model="email"><br>
    message<br><textarea v-model="message" /><br>
    <br>
    <vue-recaptcha
      @verify='onCaptchaVerified'
      @expired='onCaptchaExpired'
      class='g-recaptcha'
      sitekey="6Lcl0egUAAAAAFlbJhTWtGbJ7oxR_ILKkJn-PJ-V">
    </vue-recaptcha>
    <div v-if='!success'>captcha fail</div>
    <br>
    <button class="btn btn-primary" @click='submit'>submit</button>
  </div>
</template>

<script>
import VueRecaptcha from 'vue-recaptcha';
export default {
  name: 'contact',
  components: { VueRecaptcha },
  data () {
    return {
      name: '',
      email: '',
      message: '',
      success: true
    }
  },
  methods: {
    submit () {
      // this.status = "submitting";
      const name = this.name;
      const email = this.email;
      const message = this.message;
      const response = this.response;
      console.log('posting contact')
      this.$http.post('/contact', {
        name,
        email,
        message,
        response
      }).then((response) => {
        this.success = response.data.success
      })
    },
    onCaptchaVerified (response) {
      this.response = response;
    },
    onCaptchaExpired: function () {
    }
  },
  created () {
    let recaptchaScript = document.createElement('script')
      recaptchaScript.setAttribute('src', 'https://www.google.com/recaptcha/api.js?onload=vueRecaptchaApiLoaded&render=explicit')
      document.head.appendChild(recaptchaScript)
  }
}
</script>

<style>
  .g-recaptcha {
    display: inline-block;
  }
</style>



// WEBPACK FOOTER //
// src/components/Contact.vue